import React from "react";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import appConstants from "../../../../appConstants";
export function withTerminalsHOC(Component) {
  return class TerminalData extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        terminalList: null,
        message: appConstants.GRID_STATUS.LOADING,
      };
      this._isMounted = false;
    }
    componentDidMount() {
      this._isMounted = true;
      this.getTerminalData();
    }
    getTerminalData = () => {
      let params;
      const { shouldReturnNonTerminalLocation } = this.props;
      if (shouldReturnNonTerminalLocation) {
        params = `shouldReturnNonTerminalLocation=${shouldReturnNonTerminalLocation}`;
      }
      getDataWithQueryString("GetAllTerminals", params).then((response) => {
          if (!this._isMounted) {
            return;
          }
          if (response?.status === 200) {
            this.setState({
              terminalList: response.data ?? [],
              message: appConstants.GRID_STATUS.SUCCESS,
            });
          } else {
            this.setState({
              terminalList: [],
              message: appConstants.GRID_STATUS.ERROR,
            });
          }
        })
        .catch(() => {});
    };
    render() {
      return (
        <Component
          {...this.props}
          terminalList={this.state.terminalList}
          terminalDataMessage={this.state.message}
          getTerminalData={this.getTerminalData}
        />
      );
    }
  };
}
